import { Box, TextField, Typography, useTheme } from "@mui/material";
import { ChangeEvent } from "react";

import InfoCircle from "../../../../../media/images/icons/info-circle";

interface Props {
  name?: string;
  handleChange?: (e: ChangeEvent<any>) => void;
  value?: string;
  height?: number;
  placeholder: string;
  unit: string;
  icon?: JSX.Element;
  error?: boolean;
  errorMessage?: string | false;
}

export default function GetWithUnitInput({
  height = 48,
  placeholder,
  icon,
  error,
  errorMessage,
  unit,
  name,
  handleChange,
  value,
}: Props) {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          height: "48px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid gray",
            borderRadius: "8px",
            height: height,
            width: "100%",
            paddingX: "8px",
            gap: "8px",
          }}
        >
          {icon}
          <TextField
            type="text"
            onChange={handleChange}
            name={name}
            value={value}
            placeholder={placeholder}
            sx={{
              width: "100%",
              height: "100%",
              "& .MuiOutlinedInput-notchedOutline": {
                borderLeft: "1px solid gray !important",
                borderRight: "none",
                borderTop: "none",
                borderBottom: "none",
                outline: "none !important",
                borderRadius: "0px",
                padding: 0,
              },
              "& .MuiInputBase-input": {
                border: "none !important",
                outline: "none !important",
                padding: 0,
                fontSize: "16px",
                "&::placeholder": {
                  fontSize: "14px",
                },
              },
              "& .MuiInputBase-root": {
                border: "none !important",
                outline: "none !important",
                height: "100%",
                paddingX: "0px",
              },
              border: "none",
            }}
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              color: "tetxColor.main",
            }}
          >
            {unit}
          </Typography>
        </Box>
      </Box>
      {error && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <InfoCircle size={18} color={theme.palette.error.main} />

          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: "600",
              color: "error.main",
            }}
          >
            {errorMessage}
          </Typography>
        </Box>
      )}
    </>
  );
}
